type StatCardProps = {
  label: string;
  value: string;
  note?: string | undefined;
  tone?: 'default' | 'ok' | 'bad' | 'warn';
};

const valueColor: Record<NonNullable<StatCardProps['tone']>, string> = {
  default: 'var(--gs-ink)',
  ok: 'var(--gs-ok)',
  bad: 'var(--gs-bad)',
  warn: 'var(--gs-warn)',
};

export function StatCard({ label, value, note, tone = 'default' }: StatCardProps) {
  return (
    <div
      role="group"
      aria-label={label}
      className="flex flex-col gap-2.5 rounded-[14px] border px-5 py-[18px]"
      style={{
        background: 'var(--gs-panel)',
        borderColor: 'var(--gs-line)',
      }}
    >
      <span
        className="text-[11.5px] font-bold uppercase tracking-[0.16em]"
        style={{ color: 'var(--gs-muted)' }}
      >
        {label}
      </span>
      <span className="flex items-baseline gap-2.5">
        <span
          className="text-[34px] font-extrabold leading-none tracking-[-0.04em]"
          style={{ color: valueColor[tone] }}
        >
          {value}
        </span>
        {note ? (
          <span className="text-[13px]" style={{ color: 'var(--gs-muted)' }}>
            {note}
          </span>
        ) : null}
      </span>
    </div>
  );
}
